<template>
  <section class="instructor-access-auth-items">
      <article
        class="instructor-access-auth-item"
        v-for="item in toggleItems"
        :key="item.key">
         <section class="instructor-access-auth-item__text-area">
            <h3>{{ item.label }}</h3>
            <p>{{ item.description }}</p>
          </section>
          <section class="instructor-access-auth-item__toggle-area">
            <el-switch 
            :value="toggleModel[`handle_${item.key}`]"
            @change="onChangeToggle(item.key)"/>
          </section>
      </article>
  </section>
</template>

<script>
const toggleItems = [
    {key:'dashboard', label: '대시보드 페이지', description: '대시보드 페이지 내 모든 정보를 조회할 수 있습니다.'},
    {key:'schedule', label: '스케줄 페이지', description: '모든 스케줄을 조회하고 수업을 등록, 수정 및 삭제할 수 있습니다.'},
    {key:'timetable', label: '시간표 제작 페이지', description: '시간표 제작 페이지 내 모든 정보를 조회하고 이용할 수 있습니다. '},
    {key:'analytics', label: '통계 페이지', description: '통계 페이지 내 모든 정보를 조회하고 이용할 수 있습니다. '},
    {key:'locker', label: '락커 페이지', description: '락커 페이지 내 모든 정보를 조회하고 이용할 수 있습니다.'},
    {key:'registered_member', label: '유효/만료 회원 페이지', description: '모든 회원의 정보를 조회하고 회원의 회원권을 등록, 수정 및 삭제할 수 있습니다.'},
    {key:'pending_member', label: '승인 대기 회원 페이지', description: '대기 중인 모든 회원을 조회하고 승인/거절할 수 있습니다.'},
    {key:'create_member', label: '회원 등록 페이지', description: '회원 등록 페이지에서 신규 회원을 등록할 수 있습니다.'},
    {key:'notice', label: '공지 게시판', description: '모든 공지 게시글을 조회, 등록, 수정 및 삭제할 수 있습니다.'},
    {key:'wod', label: '오늘의 운동 게시글', description: '오늘의 운동 게시글을 조회, 등록, 수정 및 삭제할 수 있습니다.'},
    {key:'setting', label: '설정 페이지 ', description: '설정 페이지 내 모든 정보를 조회하고 이용할 수 있습니다.'},
]
export default {
    props:['toggleModel'],
    data(){
        return {
            toggleItems : toggleItems
        }
    },
    computed:{
        isLightGreyPlan() {
            return this.$store.getters.getIsLightGreyPlan
        }
    },
    watch:{
        isLightGreyPlan:{
            immediate:true,
            handler: function(value){
                if(value){
                    this.toggleItems = this.toggleItems.filter(item => item.key !== 'wod' && item.key !== 'notice');
                }
            }
        }
    },
    methods:{
        onChangeToggle(item){
            this.toggleModel[`handle_${item}`] = !this.toggleModel[`handle_${item}`]
        }
    },
}
</script>

<style lang="scss">
    .instructor-access-auth-items{
        .instructor-access-auth-item{
            &:last-child{
                margin-bottom: 25px;
            }
            display: flex;
            margin-top: 25px;
            .instructor-access-auth-item__text-area{
                width: calc(100% - 70px);
                margin-right: 10px;
                h3{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.43;
                    letter-spacing: -0.8px;
                    color: #4a4a4a;
                    margin: 0 0 5px 0;
                }
                p{  
                    margin: 0;
                    font-size: 12px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.5;
                    letter-spacing: -0.85px;
                    color: #9b9b9b;
                }
            }
            .instructor-access-auth-item__toggle-area{
                display: flex;
                .el-switch{
                    margin: auto;
                }
            }
        }
    }
</style>